module.exports = __webpack_public_path__ + "img/La_depeche.b76c7267.png";